<template>
  <BaseModal class="add-tax-modal" :title="$t('Add tax')">
    <div class="two-form-items">
      <FormInput
        id="tax-name"
        :value="localTaxName"
        class="tax-input"
        disabled
        :label-text="$t('Tax name')"
        :placeholder="$t('e.g. VAT')"
      />
      <FormInput
        id="tax-value"
        v-model="localTaxValue"
        type="number"
        class="tax-input"
        :label-text="`${$t('Tax rate')}, %`"
        placeholder="0.00%"
      />
    </div>
    <div class="add-tax-modal__buttons spacex-16">
      <Button color="neutral" @click="closeModal">
        {{ $t('Cancel') }}
      </Button>
      <Button @click="submitTax">
        {{ $t('Add tax') }}
      </Button>
    </div>
  </BaseModal>
</template>

<script>
  import FormInput from '@/components/ui/FormInput';
  import Button from '@/components/ui/Button';
  import { mapActions } from 'vuex';
  import BaseModal from '@/components/ui/BaseModal';

  export default {
    name: 'AddTaxWindow',
    components: { BaseModal, FormInput, Button },
    props: {
      context: {
        type: Object,
        default: () => ({
          taxName: String,
          taxValue: [String, Number],
          offerVersionId: Number,
          updateTax: Boolean,
          taxId: [Number, null],
        }),
      },
    },
    data() {
      return {
        localTaxName: this.context.taxName,
        localTaxValue: this.context.taxValue,
      };
    },
    methods: {
      ...mapActions({
        closeModal: 'modal/closeModal',
        addTax: 'incomingTender/addOfferVersionTax',
        updateTax: 'incomingTender/updateOfferVersionTax',
      }),
      async submitTax() {
        if (this.context.updateTax) {
          await this.updateTax({
            offerTaxId: this.context.offerTaxId,
            taxId: this.context.taxId,
            percent: this.localTaxValue,
            offerVersionId: this.context.offerVersionId,
          });
        } else {
          await this.addTax({
            taxId: this.context.taxId,
            percent: this.localTaxValue,
            offerVersionId: this.context.offerVersionId,
          });
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .add-tax-window {
    background-color: white;
    padding: 12px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    border-radius: 4px;

    .tax-input {
      margin-bottom: 0;

      ::v-deep input {
        height: 32px;
        width: 108px;
      }
    }

    .tax-btn {
      width: 32px;
      height: 32px;
      margin-bottom: 4px;

      svg {
        height: 16px;
      }
    }
  }

  .add-tax-modal {
    &__buttons {
      text-align: end;
    }
  }
</style>
